import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasemodelService } from 'src/app/basemodel.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StudentVerificationService {
  token: any;

  constructor(private http: HttpClient, public baseURL: BasemodelService) {

  }

  getRefverification(refId: any) {
    return this.http.get(environment.printasseturl + '/anonymouseUser/login/student/htNoValidate?refId=' + refId)
  }

  getverfiystudent(payload: any) {
    return this.http.post(environment.printasseturl + '/anonymouseUser/login/student/htNoVarifiction/token', payload)

  }

  postHtNoverfication(payload: any) {
    this.token = localStorage.getItem('studentToken');
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.printasseturl + '/anonymouseUser/student/api/htNoVarifiction/save', payload, { headers })
  }

  getHtverication(htticket: any) {
    this.token = localStorage.getItem('studentToken');
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/anonymouseUser/student/api/htNoVarifiction/verification?hallTicket=' + htticket, { headers })
  }

}
